/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation imports
import en from './translations/base';
import el from './translations/el';

// Misc imports
import { DEFAULT_LANGUAGE } from '../constants/env';

i18n.use(LanguageDetector).init({
  // we init with resources
  resources: {
    en: { translations: en },
    el: { translations: el }
  },
  lng: DEFAULT_LANGUAGE,
  fallbackLng: 'en',
  debug: false, // Use is.dev() to enable debug mode in development

  // Have a common namespace used around the full app
  ns: ['translations'],
  defaultNS: 'translations',

  keySeparator: false, // We use content as keys
  nsSeparator: false,

  interpolation: {
    escapeValue: false, // Not needed for React
    formatSeparator: ','
  },

  react: {
    useSuspense: true
  },

  // Allows objects as valid translation result
  returnObjects: true
});

// Change `lang` property for root element
if (document.documentElement != null) {
  document.documentElement.lang = i18n.language;
}

export default i18n;
